import { updateUser, getUser, getMe, logout } from '../../services/users.service'
import { ActionTree } from 'vuex'
import { UserState } from './user.types'
import { MutationTypes } from './user.mutations'
import { identify } from '../../services/analytics/analytics.service'
import { User } from '../../types'

export const actions: ActionTree<UserState, unknown> = {
  async updateUser({ commit }, { payload, id }: { payload: Partial<User>; id: string }) {
    try {
      commit(MutationTypes.SET_USER_LOADING, true)
      const res = await updateUser(payload, id)
      commit(MutationTypes.SET_USER, res.user)
    } catch {
      commit(MutationTypes.SET_USER_ERROR)
    } finally {
      commit(MutationTypes.SET_USER_LOADING, false)
    }
  },
  async getMe({ commit }) {
    try {
      const res = await getMe()
      commit(MutationTypes.SET_USER, res)

      identify(res)
    } catch {
      commit(MutationTypes.SET_USER_ERROR)
    }
  },
  async logout({ commit }) {
    await logout()
    commit(MutationTypes.SET_USER, null)
    window.location.href = process.env.VUE_APP_CLIENT_URI || 'http://localhost:4200'
  },
  async sessionTimeout({ commit }) {
    const url = process.env.VUE_APP_CLIENT_URI || 'http://localhost:4200'
    const inactivityRedirect = `${url}/login?reason=inactivity`
    try {
      await logout()
      window.location.href = inactivityRedirect
      commit(MutationTypes.SET_USER, null)
    } catch (e) {
      window.location.href = inactivityRedirect
    }
  },
  async getUser({ commit }, { id }) {
    try {
      const res = await getUser(id)
      commit(MutationTypes.SET_USER, res)
    } catch {
      commit(MutationTypes.SET_USER_ERROR)
    }
  }
}
